/**
 *
 * TripshockCardInfo
 *
 */

import PropTypes from 'prop-types';
import React from 'react';
import logotype from '../../images/logotype-big.svg';
import * as S from './styles';

/* eslint-disable react/prefer-stateless-function */
class TripshockCardInfo extends React.PureComponent {
    render() {
        const { children, textAlign, isNotFoundType = false, isOpen = false } = this.props;

        return (
            <S.TripshockCardInfo
                data-test-id="tripshock-card-info"
                textAlign={textAlign}
                isNotFoundType={isNotFoundType}
                isOpen={isOpen}
            >
                <S.BrandLink data-test-id="brand-link" to="/">
                    <img src={logotype} alt="TripShock!" />
                </S.BrandLink>
                <S.Content data-test-id="children">{children}</S.Content>
            </S.TripshockCardInfo>
        );
    }
}

TripshockCardInfo.propTypes = {
    children: PropTypes.node,
    textAlign: PropTypes.string,
};

TripshockCardInfo.defaultProps = {
    textAlign: 'inherit',
};

export default TripshockCardInfo;
